import { MutableRefObject, createContext } from "react";

const AddClientButtonContext = createContext<
  MutableRefObject<HTMLDivElement> | undefined
>(undefined);

export default AddClientButtonContext;
